<div class="header-action-menu d-flex justify-content-end align-items-center" #el>
  <ul class="m-0 d-flex align-items-center">
    <li class="header-action-button" *appHasRole="defaultPanelRoles">
      <app-button
        [matMenuTriggerFor]="createMenu"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.PRIMARY_GREEN,
          prependSrc: './assets/img/ic-plus-add.svg'
        }"
      />

      <mat-menu #createMenu="matMenu" yPosition="above" class="mt-1">
        <button mat-menu-item (click)="createContact()">
          <span>{{ 'Header.CreateOptions.contact' | translate }}</span>
        </button>

        <button mat-menu-item (click)="createProjectDraft()">
          <span>{{ 'Header.CreateOptions.project' | translate }}</span>
        </button>

        <button mat-menu-item (click)="createTask()">
          <span>{{ 'Header.CreateOptions.task' | translate }}</span>
        </button>

        <button mat-menu-item (click)="createTask(TaskType.TYPE_CORRECTION)">
          <span>{{ 'TaskType.correction' | translate }}</span>
        </button>

        <button mat-menu-item (click)="createTask(TaskType.TYPE_ORDER)">
          <span>{{ 'TaskType.order' | translate }}</span>
        </button>

        <button mat-menu-item (click)="createChange()">
          <span>{{ 'Header.CreateOptions.change' | translate }}</span>
        </button>

        <button mat-menu-item (click)="createEvent()">
          <span>{{ 'CalendarEvents.event' | translate }}</span>
        </button>
      </mat-menu>
    </li>
    <li class="no-hover">
      <header-action-menu-user />
    </li>
  </ul>
</div>
